import * as THREE from "three";
import { CONFIG } from "../../config";

function createDashedRingTexture(color: string): THREE.CanvasTexture {
  const { textureSize, strokeRatio, dashCount, gapRatio } = CONFIG.marker.ring;
  const canvas = document.createElement("canvas");
  canvas.width = textureSize;
  canvas.height = textureSize;

  const ctx = canvas.getContext("2d")!;
  const center = textureSize / 2;
  const lineWidth = textureSize * strokeRatio;
  const radius = (center - lineWidth - 1) / 1.75;

  ctx.strokeStyle = color;
  ctx.lineWidth = lineWidth;
  ctx.lineCap = "round";

  const segmentAngle = (Math.PI * 2) / dashCount;
  const gapAngle = segmentAngle * gapRatio;
  const dashAngle = segmentAngle - gapAngle;

  for (let i = 0; i < dashCount; i++) {
    const start = segmentAngle * i;
    ctx.beginPath();
    ctx.arc(center, center, radius, start, start + dashAngle);
    ctx.stroke();
  }

  const texture = new THREE.CanvasTexture(canvas);
  texture.needsUpdate = true;
  return texture;
}

export function createSelectionRing(color: string): THREE.Sprite {
  const texture = createDashedRingTexture(color);

  const material = new THREE.SpriteMaterial({
    map: texture,
    depthTest: false,
    depthWrite: false,
    transparent: true,
  });

  const sprite = new THREE.Sprite(material);
  sprite.renderOrder = CONFIG.marker.ring.renderOrder;
  return sprite;
}
